import { MolsonDxGrid } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'
export const StyledGrid = molsonStyled(MolsonDxGrid)(({ theme }) => ({
  '& .dx-datagrid-headers': {
    marginTop: '-12px'
  },
  '& .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-removed) > td':
    {
      backgroundColor: theme.palette.primary.lightest
    }
}))
